<template>
    <main>
        <section class="vx-row justify-center">
            <div class="vx-col w-full md:w-2/3 lg:w-3/4">
                <vx-card class="px-4">
                    <div class="mb-4">
                        <router-link class="flex items-center" to="/track-qurban">
                            <feather-icon icon="ChevronLeftIcon"></feather-icon>
                            <strong class="block">Kembali</strong>
                        </router-link>
                    </div>
                    <header class="flex flex-col justify-center mb-4">
                        <h1 id="headline" class="text-3xl md:text-4xl lg:text-5xl text-center" >
                            <strong class="text-primary">Tracking</strong>
                            <strong class="text-warning"> Qurban</strong>
                        </h1>
                    </header>
                    <section v-if="results != null && results.laporan && results.laporan.length > 0">
                        <div>
                            <qurban-progress :reports="results.laporan" />
                        </div>
                    </section>
                    <section class="mt-12" v-else>
                        <h2 class="text-center mb-6">Hasil tidak ada</h2>
                        <div class=" flex flex-col justify-center">
                            <div class="mx-auto">
                                <vs-button @click.prevent="$router.push('/track-qurban')" class="rounded-full">Coba cari lagi</vs-button>
                            </div>
                        </div>
                    </section>
                </vx-card>
            </div>
        </section>
    </main>
</template>
<script>
    import QurbanProgress from '@/views/home/user/components/ProfileQurbanProgress.vue';
    export default {
        components: {
            QurbanProgress
        },
        data: () => ({
            results: null
        }),
        created() {
            if(this.$store.state.qurban.track.kode == null) {
                this.$router.push('/track-qurban');
            }
                
            this.$vs.loading();
            this.$store.dispatch('qurban/getTrackingResult')
            .then(() => {
                this.$vs.loading.close();
                this.results = this.$store.state.qurban.track.data;
            })
            .catch(e => {
                this.$vs.loading.close();
                return false;
            });
        }
    }
</script>